import { useNavigation } from "@/providers";
import { useCreateTriggerV2 } from "@/shared/domain/triggers/hooks";

import { TriggerForm } from "../TriggerForm/TriggerForm";
import { TriggerFormPage } from "../TriggerForm/TriggerFormPage";

/** Write a new trigger and land on the page of the one that was made. */
export function CreateTrigger() {
  const { mutateAsync: createTrigger } = useCreateTriggerV2();
  const { goto } = useNavigation();

  return (
    <TriggerFormPage
      title="Create trigger"
      subtitle={"Triggers watch the platform and run targets on your behalf."}
    >
      <TriggerForm
        mode="create"
        onSubmit={async (request) => {
          const record = await createTrigger(request);
          goto.trigger({ triggerId: record.name });
        }}
        onCancel={() => goto.triggers()}
      />
    </TriggerFormPage>
  );
}
